@let c = customer();

<article class="flex items-center gap-4 rounded-lg bg-white p-4 shadow-sm transition-colors hover:bg-gray-50">
  <app-avatar [src]="c.avatarThumbnailUrl ?? undefined" [name]="c.displayName" [seed]="c.id" size="sm" />

  <div class="min-w-0 flex-1">
    <div class="flex items-center gap-2">
      <h3 class="truncate font-medium text-gray-900">{{ c.displayName || 'Unknown customer' }}</h3>
      @if (c.isFavorite) {
        <span class="text-amber-500" role="img" aria-label="Favorite" title="Favorite">★</span>
      }
    </div>
    @if (c.email) {
      <p class="truncate text-sm text-gray-500">{{ c.email }}</p>
    }
    <p class="mt-0.5 text-sm text-gray-500">
      {{ c.orderCount | number }} {{ c.orderCount === 1 ? 'order' : 'orders' }}
      · {{ c.photoCount | number }} {{ c.photoCount === 1 ? 'photo' : 'photos' }}
      @if (favoriteSize(); as size) {
        · mostly {{ size }}
      }
    </p>
    <!-- Below md the totals move under the name -->
    <p class="mt-0.5 text-sm text-gray-500 md:hidden">
      {{ spent() | currency: 'EUR' : 'symbol' : '1.2-2' }} · last order {{ (lastOrder() | date: 'd MMM y') ?? '—' }}
    </p>
  </div>

  <dl class="hidden shrink-0 gap-8 text-right md:flex">
    <div class="w-24">
      <dt class="text-xs text-gray-500">Spent</dt>
      <dd class="font-medium tabular-nums text-gray-900">{{ spent() | currency: 'EUR' : 'symbol' : '1.2-2' }}</dd>
    </div>
    <div class="w-28">
      <dt class="text-xs text-gray-500">Last order</dt>
      <dd class="tabular-nums text-gray-900">{{ (lastOrder() | date: 'd MMM y') ?? '—' }}</dd>
    </div>
  </dl>
</article>
